





















































































































































































































import {Vue, Component, Watch} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {RegistrationRequest} from '@/store/modules/registration'
import {ClientTypeState} from '@/store/modules/clientTypes'
import PhoneWithPrefix from '@/components/PhoneWithPrefix.vue'
import Validations from '@/lib/Validations'
import DateHelper from '@/lib/DateHelper'
import InputDatePicker from '@/components/InputDatePicker.vue'
import {AppConfigState} from '@/store/modules/configuration'
import CountryList from '../lib/countries'
import Stepper from '@/components/stepper.vue'
import TermsOfService from '@/components/TermsOfService.vue'
import Utils from '@/utils'
import {ExtraClientField} from '@/lib/interfaces'

@Component({
  name: 'Registration',
  components: {
    TermsOfService,
    Stepper,
    InputDatePicker,
    PhoneWithPrefix,
  },
})
export default class Registration extends Vue {
  @State('registration') public RegistrationState!: RegistrationRequest
  @State('clientTypes') public clientTypes!: ClientTypeState
  @State('configuration') public configState!: AppConfigState
  @State((state) => state.configuration.appConfig.fields_configuration) public fieldConfigState!: any
  @Action('updateRegistration') public updateRegistration: any

  public rules: any = Validations.rules
  public countries: any = CountryList

  public step: number = 0
  public steps: number = 0

  public token: string | null = null
  public registration: RegistrationRequest = new RegistrationRequest()
  // gender string must be unique
  public titleList = [
    {title: 'Mr', gender: 'M'},
    {title: 'Ms', gender: 'F'},
    {title: '-', gender: '-'},
  ]
  public maxDate: string = ''
  public sameAddress: boolean = true
  public extraClientFields: ExtraClientField[] = []

  public get clientType() {
    if (this.clientTypes && this.clientTypes.clientType) {
      const id = this.registration.client_type_id
      const obj = this.clientTypes.clientType.find((r) => r.id === id)
      return obj ? obj.type : null
    }
  }

  public get progress() {
    const step = this.step + 1
    if (this.steps > 0 && step) {
      return Math.floor((step / this.steps) * 100)
    }
    return 0
  }

  public setBirthDate(birthdate: string) {
    this.registration.birthdate = birthdate
  }

  public changeStep(steps: number, ref?: string) {
    if (this.step === 0 && steps < 0) {
      this.$router.push({name: 'home'})
    }
    if (!ref || steps < 0) {
      this.step += steps

    } else if ((this.$refs[ref] as any).validate()) {
      this.step += steps
    }
  }

  @Watch('registration', {immediate: false, deep: true})
  public registrationUpdated() {
    const addrPers = JSON.stringify(this.registration.address)
    const addrBill = JSON.stringify(this.registration.billing_address)

    this.registration.gender = this.registration.gender.slice(0, 1)
    this.registration.mobile = this.registration.phone
    if (this.sameAddress && !this.compareAddress()) {
      this.copyAddress()
      return
    }
    this.updateRegistration(this.registration)
  }

  @Watch('sameAddress', {immediate: false, deep: true})
  public sameAddressUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue && !oldValue) { // use same
      this.copyAddress()
    }
  }

  private compareAddress() {
    const addrPers = JSON.stringify(this.registration.address)
    const addrBill = JSON.stringify(this.registration.billing_address)
    return addrPers === addrBill
  }

  private copyAddress() {
    const addrPers = JSON.stringify(this.registration.address)
    this.updateRegistration({billing_address: JSON.parse(addrPers)})
    this.registration.billing_address = JSON.parse(addrPers)
  }

  private mounted() {
    this.registration = Object.assign({}, this.RegistrationState)
    this.token = (this.$route.params as any).token || null
    this.maxDate = DateHelper.now()

    const types = this.clientTypes.clientType
    if (types) {
      this.registration.client_type_id = this.registration.client_type_id || types[0].id
    }
    if (this.$refs.registrationWindow) {
      this.steps = (this.$refs.registrationWindow as any).items.length
    }

    this.extraClientFields = this.configState.appConfig.extra_client_fields
    if (this.configState.appConfig.hasOwnProperty('extra_client_fields')) {
      if (!this.registration.extra || !Object.keys(this.registration.extra).length) {
        this.$set(this.registration, 'extra', {})
        this.extraClientFields.forEach((extra) => {
          Object.assign(this.registration.extra, {[extra.value]: ''})
        })
      }
    }

    this.setDefaultsFields()
  }

  // fields configurations

  private fieldConfig(field: string) {
    if (!this.fieldConfigState) {
      return {
        fields: [],
        defaultValue: null,
      }
    }

    const path = field.split('.')
    path.unshift(this.registration.client_token ? 'driver' : 'client')


    const fields = (Utils.getProp(this.fieldConfigState, path) || '').split('|') || []
    let defaultValue = fields.find((q: string) => q.startsWith('default:') && !!q.split(':')[1]) || null
    if (defaultValue) {
      const defaultIndex = fields.indexOf(defaultValue)
      // store default value
      defaultValue = defaultValue.split(':')[1]
      // remove default from fields
      fields.splice(defaultIndex, 1)
    }
    return {
      fields,
      defaultValue,
    }
  }

  private setDefaultsFields() {
    const config = (key: string) => this.fieldConfig(key)
    const doStuff = (key: string) => {
      const fieldIsHidden = (config(key).fields as string[]).includes('hidden')
      const fieldHasDefaultValue = config(key).defaultValue !== null
      const targetFieldIsEmpty = !this.registration[key]

      if (fieldIsHidden && fieldHasDefaultValue) {
        Utils.setProp(this.registration, key.split('.'), config(key).defaultValue || '')
      } else if (fieldHasDefaultValue && targetFieldIsEmpty) {
        Utils.setProp(this.registration, key.split('.'), config(key).defaultValue || '')
      }
    }

    Object.keys(this.registration).forEach((key: string) => {
      if (typeof this.registration[key] !== 'object') {
        doStuff(key)
      } else {
        Object.keys(this.registration[key]).forEach((k: string) => {
          doStuff([key, ...k.split('.')].join('.'))
        })
      }
    })
  }

  // extra rules

  private extraRules(key: string) {
    if (this.extraClientFields.length) {
      const extra = this.extraClientFields.find((field) => {
        return field.value === key
      })
      if (extra && extra.validation) {
        const validation = extra.validation
        const rulesArray: [() => boolean] | null[] = []
        validation.split('|').forEach((rule) => {
          if (rule.startsWith('digits_between')) {
            const x = rule.split(':').pop()
            if (x) {
              const minMax = x.split(',') as string[]
              rulesArray.push(this.rules.digitsBetween(minMax[0], minMax[1]))
            }
          }
          switch (rule) {
            case 'required':
              rulesArray.push(this.rules.required)
              break
            case 'numeric':
              rulesArray.push(this.rules.number)
              break
            case 'boolean':
              rulesArray.push(this.rules.boolean)
              break
          }
        })
        if (validation && validation.includes('nullable')) {
          rulesArray.push(this.rules.nullable)
        }
        return rulesArray
      }
    }
  }
}
